import { render, staticRenderFns } from "./AddContactUser.vue?vue&type=template&id=05055fae"
import script from "./AddContactUser.vue?vue&type=script&lang=js"
export * from "./AddContactUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports